// Tiny, dependency-free display-mode helpers. Extracted out of pwaUtils so that
// modules needed in the pre-React service-worker bootstrap bundle (pwaEventTracking
// → logPwaEvent, pwaSwDiagnostics) can detect standalone mode WITHOUT importing the
// heavy pwaUtils module (theme/manifest logic). pwaUtils re-exports isStandalone so
// existing import sites are unaffected.

export function isStandalone(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as any).standalone === true
  );
}
